export function readCookie(name: string): string | null {
  const source = typeof document !== 'undefined' ? document.cookie : '';
  if (!source) return null;

  const parts = source.split(';');
  for (const part of parts) {
    const [rawKey, ...rest] = part.trim().split('=');
    if (rawKey === name) {
      const value = rest.join('=');
      if (!value) return null;

      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  }

  return null;
}

export function setSessionCookie(name: string, value: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;SameSite=Lax";
}

export function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
}

export function getCsrfToken(): string | null {
  const csrfCookie = readCookie('csrf_token');
  if (!csrfCookie) {
    return null;
  }

  return csrfCookie.includes('|') ? csrfCookie.split('|')[0] : csrfCookie;
}
